import { render } from "./PlayerPreview.vue?vue&type=template&id=b10a7e4c&scoped=true"
import script from "./PlayerPreview.vue?vue&type=script&lang=js"
export * from "./PlayerPreview.vue?vue&type=script&lang=js"

import "./PlayerPreview.vue?vue&type=style&index=0&id=b10a7e4c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10a7e4c"]])

export default __exports__